<template>
    <div>
        <div v-for="child in children" :key="child.id" class="node-type-lb">
            <input 
                type="radio" v-model="selectedLabel" :value="child.id"
                v-bind="{
                    id   : child.id + '_radioButton',
                    name : node.id + '_radioGroup',
                }"
            />
            <label 
                v-bind="{
                    id  : child.id + '_label',
                    for : child.id + '_radioButton'
                }"
            >
                {{ child.layout.caption }}
            </label>
        </div>

    </div>
</template>

<script>
import { gConsts } from '@/globals/gConsts';
import { utils   } from '@/globals/utils';
import { mapGetters, mapState, mapActions } from 'vuex';


export default {
    name : 'layerRadioGroupCMP',
    props: {
        children : Array,        
        node     : Object,
        id       : String 
    }, 

    // -----------------------------------------------------------------

    data () {
        return {
        }
    },

    // -----------------------------------------------------------------

    computed: {
        ...mapState([
        ]),

        ...mapGetters([
            'GET_activeElem',
        ]),
        // -----------------------------------------------------------------

        console() { return console },

        // -----------------------------------------------------------------

        selectedLabel: {
            get() {
                return this.GET_activeElem?.labels?.[this.node.id] ?? '';
            },
            set(value) {
                this.ACT_jobUpdate({ labels : { layer : this.node.id, label : value } });
            }
        },
    },

    // -----------------------------------------------------------------
    // -----------------------------------------------------------------

    watch: {
    },

    // -----------------------------------------------------------------
    // -----------------------------------------------------------------

    methods: {
        ...mapActions([
            'ACT_jobUpdate',
        ]),

        // -----------------------------------------------------------------

        radioChange(evt) {
            // This method will be called before the watcher.
            // Perform any immediate actions needed before the watcher reacts to the change.

        }
    },

    mounted() {
//        this.selectedLabel = 'lb_denticaoPermanente';
    },
}

</script>

// =========================================================================================
// =========================================================================================

<style>
li {
    font-size: 0.8em;
    left: 25px;
    margin-left: 5px;
    margin-top: 5px;
}

.node-type-lb {
    font-size: 0.8em;
    left: 25px;
    margin-left: 5px;
    margin-top: 4px;
}


</style>